import { useContext, useEffect, useState } from "react";
import RightArrow from "../../../../../images/ArrowRight.svg";
import { useLazyQuery } from "@apollo/client";
import { DashboardVars, GetDashboardItemAndJunctionCountData } from "./types";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import { AddModalStyles } from "../../../../../styles/CustomModalStyles";
import { PageFor, PageFrom } from "../../../../../utils/Enum.types";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import Table, { ItemDetailsTableFor } from "../../reports/assetwise/Table";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import TrafficSignalDetails from "./view/TrafficSignalDetails";
import { GetDashboardItemAndJunctionCount } from "./queries";
import { TableType } from "../../../customer/companies/queries/types";
import useLabels from "../../../../../customHooks/useLabels";
import ParticularAssetDetails from "../dashboardcomponents/ParticularAssetDetails/Index";
import { emptyModal } from "../../masters/grouping/asset/AssociateGroupItemsDetails";
import { pollingMinutes } from "../../../../../utils/constants";

const AssetDetails = () => {
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [viewAssets, setviewAssets] = useState(false);
  const [detailAssets, setDetailAssets] = useState(false);
  const { dispatch, state } = useContext(AppContext);

  const [modalFlag, setModalFlag] = useState(emptyModal);
  const { itemLabel } = useLabels();
  const [GetDashboardItems, { data }] = useLazyQuery<
    GetDashboardItemAndJunctionCountData,
    DashboardVars
  >(GetDashboardItemAndJunctionCount,{
    pollInterval: pollingMinutes
  });
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardItems({
        variables: {
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0,
        },
      });
    }
  }, [customer_id, user_details.id, GetDashboardItems]);

  return (
    <div className="d-asset-details">
      <b className="d-main-page__block--title">My {itemLabel} </b>
      <div className="d-asset-details__ul">
        <ul>
          {data ? (
            data.GetDashboardItemAndJunctionCount.map((res, index) => {
              const img = require(`../../../../../images/ItemIcons/${
                res.icon ? res.icon : "item"
              }.svg`);

              return (
                <li
                  key={index}
                  onClick={() => {
                    dispatch({
                      type: payloadTypes.SET_ITEM_ID,
                      payload: {
                        itmId: res.id,
                        itmDesc: res.desc,
                      },
                    });
                    if (res.tableLevel === TableType.ASSET)
                    setDetailAssets(!detailAssets);
                    else {
                      setviewAssets(!viewAssets);
                    }
                  }}
                >
                  <div className="d-asset-details--flex">
                    <span>{index + 1}</span>
                    <img src={img} alt="/" />
                    <label>{res.desc}</label>
                  </div>
                  <div className="d-asset-details--flex">
                    <b>{res.count}</b>
                    <img src={RightArrow} alt="" />
                  </div>
                </li>
              );
            })
          ) : (
            <b className="nodata">No data found</b>
          )}
        </ul>
      </div>

      {/* <button
        className="d-asset-details__button"
        onClick={() => setviewAssets(!viewAssets)}
      >
        View All
      </button> */}

      <CustomModal
        style={AddModalStyles}
        isOpen={viewAssets}
        onRequestClose={() => setviewAssets(!viewAssets)}
        contentComponent={
          // <Items setModalFlag={setviewAssets} pageType={PageFor.MODAL} />

          <TrafficSignalDetails setModalFlag={setviewAssets} />
        }
      />

      <CustomModal
        style={AddModalStyles}
        isOpen={modalFlag.flag}
        onRequestClose={() => setModalFlag(emptyModal)}
        contentComponent={
          <>
            <div className="d-asset-details__complete-details">
              <div className="d-asset-details__complete-details--title">
                <Title>{state.itmDesc ? state.itmDesc : ""}</Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => setModalFlag(emptyModal)}
                />
              </div>

              <Table
                pageType={ItemDetailsTableFor.ASSET_WISE}
                type={PageFor.MODAL}
                setModalFlag={setModalFlag}
              />
            </div>
          </>
        }
      />

      <CustomModal
        style={AddModalStyles}
        isOpen={detailAssets}
        onRequestClose={() => setDetailAssets(!detailAssets)}
        contentComponent={
          <ParticularAssetDetails setDetailAssets={setDetailAssets} />
        }
      />
    </div>
  );
};

export default AssetDetails;
